export function valueOrHyphen(value: string | undefined): string {
  return value ?? '-';
}
